export default __webpack_public_path__ + "static/media/layout-3.6b1b041b.jpg";